import {Component} from '@angular/core';

@Component({
    selector: 'dk-currency-rate',
    inputs: ['rate'],
    template: require('./currency-rate.html')
})

export class CurrencyRateComponent {
    public rate: any;
}
